import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Progress } from "../lib";
import { Content } from "../pages/Template";
import { logoutUser } from "../reducers/user/actions";

const Wrapper = styled.div`
    text-align: center;
    margin: 70px auto 0 auto;
`;

type Props = DispatchProps;
class LogoutPage extends React.Component<Props> {
    static paths = ["/app/logout"];
    static requiresAuth = true;

    componentDidMount() {
        this.props.logoutUser(null);
    }

    render() {
        return (
            <Content>
                <Wrapper>
                    <Progress />
                </Wrapper>
            </Content>
        );
    }
}

const mapDispatch = { logoutUser };
type DispatchProps = typeof mapDispatch;
export default connect(null, mapDispatch)(LogoutPage);
